export const dimensions = {
  mobile: '23.5rem',
  tablet: '48rem',
  laptop: '75rem',
  desktop: '112rem',
} as const
